import * as types from './actionTypes';
import { getSavedFiltersBasedOnSearchTypeId, postActiveFilterValues, deleteSavedFilter } from '../api/searchFilterApi';

export function setFitlerListSuccess(filters) {
  return {
    type: types.SET_SAVED_FILTER_LIST_SUCCESS,
    filters,
  };
}

export function fetchSavedFilterElements(searchTypeId) {
  return (dispatch) => {
    if (searchTypeId === -1) {
      dispatch(setFitlerListSuccess([]));
      return [];
    }

    return getSavedFiltersBasedOnSearchTypeId(searchTypeId)
      .then((apiResponse) => {
        dispatch(setFitlerListSuccess(apiResponse.data));
      })
      .catch(() => {
        dispatch(setFitlerListSuccess([]));
      });
  };
}

export function saveActiveFilters(searchTypeId, activeFilters, filterName) {
  return (dispatch) => {
    return postActiveFilterValues(searchTypeId, activeFilters, filterName)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          dispatch(fetchSavedFilterElements(searchTypeId));
        }
      })
      .catch((error) => {
        console.warn('error received while saving filters based on searchTypeId', error);
      });
  };
}

export function deleteSavedFilters(filterId, searchTypeId) {
  return (dispatch) => {
    return deleteSavedFilter(filterId)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          dispatch(fetchSavedFilterElements(searchTypeId));
        }
      })
      .catch((error) => {
        console.warn('error received while deleting filters based on filterId', error);
      });
  };
}
